export const camelToKebabCase = (str: string) =>
  str.replace(/[A-Z]/g, (char) => `-${char.toLowerCase()}`);
